// extracted by mini-css-extract-plugin
export default {"card":"TUvOe3","petInfo":"MTmYfu","petName":"gmFfFE"};